import { Question, QUESTION_TYPES } from '@commutifi-fe/interfaces'
import { ICustomQuestionProps } from 'shared/interfaces/Survey'
import { subQuestionIdPrefix } from 'constants/onboarding'
import { baseQuestion } from 'constants/surveys'

export const primaryRouteQId = `${subQuestionIdPrefix}primary-route-id`
export const secondaryRouteModesQId = `${subQuestionIdPrefix}secondary-route-modes-id`
export const multiModesQuestion = (props: ICustomQuestionProps): Question => ({
  ...baseQuestion,
  type: QUESTION_TYPES.commuteTimeline,
  order: 1,
  ...props,
  content: {
    id: 'complexe-modes',
    questionId: props.id,
    locale: 'en-US',
    ...props.content
  }
})

export const secondaryRouteQId = `${subQuestionIdPrefix}secondary-route-id`
export const secondaryRouteQuestion = (props: ICustomQuestionProps): Question => ({
  ...baseQuestion,
  type: QUESTION_TYPES.secondaryCommuteRouter,
  order: 2,
  ...props,
  content: {
    id: 'secondary-route',
    questionId: props.id,
    locale: 'en-US',
    ...props.content
  }
})
